import React from "react";
import { Select } from "@chakra-ui/react";

const NumberSelect = ({
  start = 1,
  end = 10,
  interval = 1,
  value,
  onChange,
  disabled = false,
}) => {
  const options = [];

  for (let i = start; i <= end; i += interval) {
    options.push(i);
  }

  const selectProps = {
    "data-testid": "NumberSelect",
    variant: "primary",
    disabled,
  };

  if (value !== undefined) {
    selectProps.value = value;
  }

  if (onChange) {
    selectProps.onChange = onChange;
  }

  return (
    <Select {...selectProps}>
      {options.map((num) => (
        <option key={num} value={num}>
          {num}
        </option>
      ))}
    </Select>
  );
};

NumberSelect.displayName = "NumberSelect";

export default NumberSelect;
